import { NavLink } from 'react-router-dom';
import { SocialIcon } from 'react-social-icons';

const Footer = () => (
  <footer>
    <div className="footer-grid">
      <div className="footer-brand">
        <img src='/myfundztmw.png' alt="My Fundz Logo" className="footer-logo" />
        <p className="footer-tagline">S MEENATCHI</p>
        <p>AMFI REGISTERED MUTUAL FUND DISTRIBUTOR</p>
        <p>ARN-174612</p>
        {/* <p>Trusted Financial Planning Services In Puducherry</p>
        <p>Services Handled Across India</p>
        <p>Consultations By Appointment.</p> */}
        <p>Legacy Of Trust Since 1985.</p>
        <p>Your Financial Partner For Life.</p>


        <div className="social-links">
          <SocialIcon
            url="https://www.linkedin.com/in/meenatchisankaran?utm_source=share_via&utm_content=profile&utm_medium=member_android"
            target="_blank"
            rel="noopener noreferrer"
            title="Connect on LinkedIn"
          />
          <SocialIcon
            url="https://www.instagram.com/myfundzmeenatchi?igsh=MWdvdm5wdjFpZmpzdA%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            title="Follow on Instagram"
          />
          <SocialIcon
            url="https://www.youtube.com/channel/UCrb1234567890"
            target="_blank"
            rel="noopener noreferrer"
            title="Watch on YouTube"
          />
        </div>
      </div>
      <div className="footer-section">
        <h4>Services</h4>
        <ul>
          <li><span className="footer-text-link">Portfolio Management Services (PMS)</span></li>
          <li><span className="footer-text-link">Retirement Planning (NPS & Bonds)</span></li>
          <li><span className="footer-text-link">Corporate Deposit</span></li>
          <li><span className="footer-text-link">Insurance Planning</span></li>
        </ul>
      </div>
      <div className="footer-section">
        <h4>Pages</h4>
        <ul>
          <li><NavLink to="/about">About Us</NavLink></li>
          <li><NavLink to="/calculators">Calculators</NavLink></li>
          <li><NavLink to="/services">Services</NavLink></li>
          <li><NavLink to="/why-choose-us">Why Choose Us</NavLink></li>
          <li><NavLink to="/contact">Contact Us</NavLink></li>
        </ul>
      </div>
      <div className="footer-section">
        <h4>Let's Connect</h4>
        <ul>
          <li><span className="footer-text-link">Connect With A Trusted Investment Advisor Today</span></li>
          <li><span className="footer-text-link">Start Planning Your Financial Future</span></li>
          <li><NavLink to="/contact">Contact Us</NavLink></li>
        </ul>
      </div>
      <div className="footer-section">
        <h4>Download App</h4>
        <div className="app-download-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=in.mymfbox"
            target="_blank"
            rel="noopener noreferrer"
            className="app-btn"
          >
            <svg viewBox="0 0 24 24" className="app-icon" fill="currentColor">
              <path d="M3,5.27V18.73L16.55,12L3,5.27M17.87,11.33L19.45,12.12L17.87,12.91V11.33M3,3C2.8,3 2.6,3.06 2.42,3.17L12.57,10L3,3M3,21L12.57,14L2.42,20.83C2.6,20.94 2.8,21 3,21M17.47,9.5L13.88,11.33L16.55,12L17.47,9.5M17.47,14.5L16.55,12L13.88,12.67L17.47,14.5Z" />
            </svg>
            <div className="app-btn-text">
              <span className="app-btn-sub">GET IT ON</span>
              <span className="app-btn-main">Google Play</span>
            </div>
          </a>
          <a
            href="https://apps.apple.com/sg/app/themfbox/id1594370380"
            target="_blank"
            rel="noopener noreferrer"
            className="app-btn"
          >
            <svg viewBox="0 0 24 24" className="app-icon" fill="currentColor">
              <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,22C14.32,22.05 13.89,21.24 12.37,21.24C10.84,21.24 10.37,21.97 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.1,16.67C20.08,16.74 19.67,18.11 18.71,19.5M15.97,4.17C16.63,3.37 17.07,2.28 16.95,1C16,1.04 14.9,1.6 14.24,2.38C13.68,3.04 13.19,4.14 13.34,5.39C14.39,5.47 15.4,4.88 15.97,4.17Z" />
            </svg>
            <div className="app-btn-text">
              <span className="app-btn-sub">Download on the</span>
              <span className="app-btn-main">App Store</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <p>2025 MYFUNDZ. All Right Reserved</p>
      {/* <div className="footer-bottom-links">
        <span className="footer-text-link">Privacy Policy</span>
        <span className="footer-text-link">Term Of Use</span>
      </div> */}
    </div>
  </footer>
);

export default Footer;
